export default class brandTab {
    constructor() {

        this.status = {
            tab : {
                select : "jp"
            },
            slide : {
                jp : {
                    current : 0,
                    prevCurrent : 0,
                    total : 0,
                    mot : false
                },
                overseas : {
                    current : 0,
                    prevCurrent : 0,
                    total : 0,
                    mot : false
                }
            }
        }

        this.conf = {
            slide :{
                num : 12, //一度に表示させる数
            }
        }


        this.$tabWrap = {
            jp : "",
            overseas:"",
            body : ""
        }

        this.$list = {
            jp : "",
            overseas : "",
            current : {//表示中のリストだけ保存
                jp : [],
                overseas : [],
            },
            pager : {
                jp : "",
                overseas : "",
            },
            arrow : {
                jp : "",
                overseas : "",
            }
        }

    }
    init(){


        this.$tabWrap.jp = document.querySelector(".brand-jp")
        this.$tabWrap.overseas = document.querySelector(".brand-overseas")
        this.$tabWrap.body = document.querySelector(".brand-body")

        this.$list.jp = this.$tabWrap.jp.querySelectorAll(".brand-item")
        this.$list.overseas = this.$tabWrap.overseas.querySelectorAll(".brand-item")

        this.$list.pager.jp = this.$tabWrap.jp.querySelectorAll(".num-list .num")
        this.$list.pager.overseas = this.$tabWrap.overseas.querySelectorAll(".num-list .num")

        // slide pagerの上限
        this.status.slide.jp.total = Math.ceil(this.$list.jp.length/this.conf.slide.num)
        this.status.slide.overseas.total = Math.ceil(this.$list.overseas.length/this.conf.slide.num)

        this.$list.arrow.jp = this.$tabWrap.jp.querySelectorAll(".js__arrow")
        this.$list.arrow.overseas = this.$tabWrap.overseas.querySelectorAll(".js__arrow")


        // slide pager それぞれ初期表示のlistを保存
        this._litUpdate("jp");
        this._litUpdate("overseas");

        this._listShow("jp");
        this._listShow("overseas");
        TweenMax.set(this.$list.current['overseas'],{display:"block"})

        //表示している要素の高さに合わせる
        setTimeout(()=>{
            TweenMax.set(this.$tabWrap.body,{
                height : this.$tabWrap[this.status.tab.select].clientHeight,
            })
        },1e3)


        //slide pager イベント定義
        for (let i in this.$list.pager.jp) {
            if (this.$list.pager.jp[i].nodeType != 1) break
            this.$list.pager.jp[i].addEventListener("click",(e)=>{

                if(this.status.slide.jp.current==i) return;

                this.status.slide.jp.current = Number(e.target.getAttribute("data-no"))
                this._listOut("jp")

                this.$list.pager.jp[this.status.slide.jp.current].classList.add("is-current")
                this.$list.pager.jp[this.status.slide.jp.prevCurrent].classList.remove("is-current")

                this.status.slide.jp.prevCurrent = this.status.slide.jp.current
            })
        }
        for (let i in this.$list.pager.overseas) {
            if (this.$list.pager.overseas[i].nodeType != 1) break
            this.$list.pager.overseas[i].addEventListener("click",(e)=>{

                if(this.status.slide.jp.current==i) return;

                this.status.slide.overseas.current = Number(e.target.getAttribute("data-no"))
                this._listOut("overseas")

                this.$list.pager.overseas[this.status.slide.overseas.current].classList.add("is-current")
                this.$list.pager.overseas[this.status.slide.overseas.prevCurrent].classList.remove("is-current")

                this.status.slide.overseas.prevCurrent = this.status.slide.overseas.current
            })
        }


        //矢印
        for (let i in this.$list.arrow.jp) {
            if (this.$list.arrow.jp[i].nodeType != 1) break
            this.$list.arrow.jp[i].addEventListener("click",(e)=>{

                if(this.status.slide.jp.mot) return;
                this.status.slide.jp.mot = true;

                if(e.target.classList.contains("arrow-right")){
                    this.status.slide.jp.current = this.status.slide.jp.total>this.status.slide.jp.current? this.status.slide.jp.current+1 : this.status.slide.jp.total
                }else{
                    this.status.slide.jp.current = 0<this.status.slide.jp.current? this.status.slide.jp.current-1 : 0
                }

                if(this.status.slide.jp.current==this.status.slide.jp.prevCurrent) return;


                if(this.status.slide.jp.current==0) {
                    this.$tabWrap.jp.querySelector(".arrow-left").classList.add("is-disable")
                }else{
                    this.$tabWrap.jp.querySelector(".arrow-left").classList.remove("is-disable")
                }
                if(this.status.slide.jp.current==this.status.slide.jp.total-1) {
                    this.$tabWrap.jp.querySelector(".arrow-right").classList.add("is-disable")
                }else{
                    this.$tabWrap.jp.querySelector(".arrow-right").classList.remove("is-disable")
                }

                this._listOut("jp")
                this.$list.pager.jp[this.status.slide.jp.current].classList.add("is-current")
                this.$list.pager.jp[this.status.slide.jp.prevCurrent].classList.remove("is-current")
                this.status.slide.jp.prevCurrent = this.status.slide.jp.current
            })
        }
        for (let i in this.$list.arrow.overseas) {
            if (this.$list.arrow.overseas[i].nodeType != 1) break
            this.$list.arrow.overseas[i].addEventListener("click",(e)=>{

                if(this.status.slide.overseas.mot) return;
                this.status.slide.overseas.mot = true;

                if(e.target.classList.contains("arrow-right")){
                    this.status.slide.overseas.current = this.status.slide.overseas.total>this.status.slide.overseas.current? this.status.slide.overseas.current+1 : this.status.slide.overseas.total
                }else{
                    this.status.slide.overseas.current = 0<this.status.slide.overseas.current? this.status.slide.overseas.current-1 : 0
                }

                if(this.status.slide.overseas.current==this.status.slide.overseas.prevCurrent) return;

                if(this.status.slide.overseas.current==0) {
                    this.$tabWrap.overseas.querySelector(".arrow-left").classList.add("is-disable")
                }else{
                    this.$tabWrap.overseas.querySelector(".arrow-left").classList.remove("is-disable")
                }
                if(this.status.slide.overseas.current==this.status.slide.overseas.total-1) {
                    this.$tabWrap.overseas.querySelector(".arrow-right").classList.add("is-disable")
                }else{
                    this.$tabWrap.overseas.querySelector(".arrow-right").classList.remove("is-disable")
                }


                this._listOut("overseas")
                this.$list.pager.overseas[this.status.slide.overseas.current].classList.add("is-current")
                this.$list.pager.overseas[this.status.slide.overseas.prevCurrent].classList.remove("is-current")
                this.status.slide.overseas.prevCurrent = this.status.slide.overseas.current
            })
        }
        //タブ切り替え
        document.querySelector(".jp-tab").addEventListener("click",(e)=>{

            if(this.status.tab.select == "jp") return

            this.status.tab.select = "jp"

            document.querySelector(".overseas-tab").classList.remove("is-active")
            this.$tabWrap.overseas.classList.remove("is-active")
            this.$tabWrap.jp.classList.add("is-active")
            e.target.classList.add("is-active")

            this._show(this.$tabWrap.jp)
            this._out(this.$tabWrap.overseas)


        })
        document.querySelector(".overseas-tab").addEventListener("click",(e)=>{

            if(this.status.tab.select == "overseas") return

            document.querySelector(".jp-tab").classList.remove("is-active")
            e.target.classList.add("is-active")

            this.$tabWrap.overseas.classList.add("is-active")
            this.$tabWrap.jp.classList.remove("is-active")


            this.status.tab.select = "overseas"
            this._out(this.$tabWrap.jp)
            this._show(this.$tabWrap.overseas)

        })


    }
    render(mouse,scrollInc){

    }
    resize(w,h,deviceSize){


    }
    _show($target){


        TweenMax.to(this.$tabWrap.body, 0.6 ,{
            height : $target.clientHeight,
        })

        TweenMax.to($target,.6,{
            opacity : 1,
        })
        // TweenMax.fromTo($target.querySelectorAll('.brand-item'),0.3,{
        //     opacity : 0,
        //     y: 20
        // },{
        //     // delay: 0.6,
        //     opacity : 1,
        //     y: 0
        // },0.05)

    }
    _out($target){
        TweenMax.to($target,.6,{
            // delay: 0.6,
            opacity : 0,
        })
        // TweenMax.to($target.querySelectorAll('.brand-item'),0.3,{
        //     opacity : 0,
        //     y: 20
        // },0.05)

    }
    // 表示させるものを更新
    _litUpdate(select){

        let _no = 0

        const _s = this.status.slide[select].current*this.conf.slide.num;
        const _e = _s + this.conf.slide.num;

        for (let i in this.$list[select]) {
            if (this.$list[select][i].nodeType != 1) break

            if(_s<=i&&_e>i){

                this.$list.current[select][_no] = this.$list[select][i]
                _no += 1
            }


        }

    }
    _listShow(select){

        TweenMax.set(this.$list.current[select],{display:"block"})

        TweenMax.staggerTo(this.$list.current[select],0.6,{
            opacity : 1,
            y :0,
            ease:Power1.easeOut,
        },0.015,()=>{
            this.status.slide[select].mot = false
        })

    }
    _listOut(select){

        TweenMax.killTweensOf(this.$list.current[select],{
            opacity : true,
            y : true,
        })

        TweenMax.staggerTo(this.$list.current[select],0.6,{
            opacity : 0,
            y :10,
            ease:Power1.easeOut,
            onComplete:()=>{
            }
        },0.015,()=>{
            TweenMax.killTweensOf(this.$list.current[select],{
                opacity : true,
                y : true,
            })
            TweenMax.set(this.$list.current[select],{display:"none"})
            this._litUpdate(select)
            this._listShow(select)
            // setTimeout(()=>{
            // },5e2);
        })

    }
}